import { render, staticRenderFns } from "./RoomCard.vue?vue&type=template&id=30395bcd&"
import script from "./RoomCard.vue?vue&type=script&lang=js&"
export * from "./RoomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30395bcd')) {
      api.createRecord('30395bcd', component.options)
    } else {
      api.reload('30395bcd', component.options)
    }
    module.hot.accept("./RoomCard.vue?vue&type=template&id=30395bcd&", function () {
      api.rerender('30395bcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/RoomCard.vue"
export default component.exports